export const upgradedUrlOverrideStyle = {
  '& .custom-params-template .custom-param-entry': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .custom-params-template .custom-param-entry td': {
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .custom-params-template .flex-row-fixed.custom-param__key-container': {
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .custom-params-template .flex-row-fixed.custom-param__key-container .control-label': {
    whiteSpace: 'pre',
  },
  '& .custom-params-template .flex-row-fixed.custom-param__key-container input.form-control.custom-param__key-field': {
    margin: '0px 5px',
  },
  '& .custom-params-template .flex-row-dynamic input.form-control.custom-param__value-field': {
    marginLeft: '5px',
  },
  '& .custom-params-template .closeimage.custom-param__close-button': {
    height: '20px',
    display: 'flex',
    alignItems: 'center',

    '&:before': {
      fontFamily: '"MsAds MDL2 Assets"',
      content: '"\\E711"',
    },
  },
  '& .custom-param__close-button': {
    marginLeft: 10,
    cursor: 'pointer',
  },
};
